import isDeviceTypeMobile from "../../../../../utils/isDeviceTypeMobile/isDeviceTypeMobile";

const generateAd = () => ({});

const addAds = (items: any[]) => {
    const gridAdEnabled = false;
    let itemsWithAds: object[] = [];
    if (gridAdEnabled) {
        let addPlace = isDeviceTypeMobile() ? 8 : 10;
        for (let i = 0; i < items.length; i++) {
            if (i % addPlace === 0 && i !== 0) {
                itemsWithAds.push(generateAd());
            }
            itemsWithAds.push(items[i]);
        }
        return itemsWithAds;
    }
    return items;
};

export default addAds;
